import { render, staticRenderFns } from "./CheckboxesFormGroup.vue?vue&type=template&id=505ccae4&scoped=true&"
import script from "./CheckboxesFormGroup.vue?vue&type=script&lang=js&"
export * from "./CheckboxesFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxesFormGroup.vue?vue&type=style&index=0&id=505ccae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ccae4",
  null
  
)

export default component.exports